/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('rebatesModal', [function() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                '$filter',
                'AccountAuthService',
                'IndexService',
                'RebatesService',
                'UtilService',
                'CmsContentService',
                function (
                    $scope,
                    $filter,
                    AccountAuthService,
                    IndexService,
                    RebatesService,
                    UtilService,
                    CmsContentService
                ) {
                    $scope.currentUser = null;
                    $scope.is_authenticated = AccountAuthService.isAuthenticated();
                    $scope.receipt = null;
                    $scope.userEmail = '';
                    $scope.emailSent = false;
                    $scope.sendEmail = false;
                    $scope.showUploadReceipt = false;

                    $scope.rebate = null;
                    $scope.productDetailData = null;
                    $scope.rebate_valid = '';
                    $scope.rebate_provider = '';

                    $scope.allowEasyRebate = RebatesService.allowEasyRebate();
                    $scope.allowEmailRebate = RebatesService.allowEmailRebate();
                    $scope.allowInstantRebate = false;
                    $scope.showRebateImage = RebatesService.showRebateImage();

                    var visitorType = AccountAuthService.getUserStatus();

                    var processCMSData = function() {

                        CmsContentService.getMarketPlaceText('base:modals:receipt_upload_button_text').then(function(text) {
                            $scope.receipt_upload_button_text = text;
                        });

                        CmsContentService.getMarketPlaceText(
                            'base:modals:unauthed_easy_rebate_text',
                            {
                                'brand': $scope.productDetailData.brand,
                                'model_number': $scope.productDetailData.model_number,
                            }
                        ).then(function(text) {
                            $scope.unauthed_easy_rebate_text = text;
                        });

                        CmsContentService.getMarketPlaceText(
                            'base:modals:unauthed_no_easy_email_rebate_text',
                            {
                                'brand': $scope.productDetailData.brand,
                                'model_number': $scope.productDetailData.model_number,
                            }
                        ).then(function(text) {
                            $scope.unauthed_no_easy_email_rebate_text = text;
                        });

                        CmsContentService.getMarketPlaceText(
                            'base:modals:unauthed_no_easy_no_email_rebate_text',
                            {
                                'brand': $scope.productDetailData.brand,
                                'model_number': $scope.productDetailData.model_number,
                            }
                        ).then(function(text) {
                            $scope.unauthed_no_easy_no_email_rebate_text = text;
                        });

                        CmsContentService.getMarketPlaceText(
                            'base:modals:authed_easy_rebate_text',
                            {
                                'brand': $scope.productDetailData.brand,
                                'model_number': $scope.productDetailData.model_number,
                            }
                        ).then(function(text) {
                            $scope.authed_easy_rebate_text = text;
                        });

                        CmsContentService.getMarketPlaceText(
                            'base:modals:authed_no_easy_rebate_text',
                            {
                                'brand': $scope.productDetailData.brand,
                                'model_number': $scope.productDetailData.model_number,
                            }
                        ).then(function(text) {
                            $scope.authed_no_easy_rebate_text = text;
                        });

                        CmsContentService.getMarketPlaceText('instant_rebate:buying_a_new_product', {
                            product_type: $scope.productDetailData.category.name.toLowerCase()
                        }).then(function(text) {
                            $scope.buyingANewProductText = text;
                        });

                        CmsContentService.getMarketPlaceText('instant_rebate:apply_for_rebate', {
                            rebate_amount: $filter('toCurrency')($scope.productDetailData.rebate.amount)
                        }).then(function(text) {
                            $scope.applyForInstantRebateText = text;
                        });

                        var rebate_title_cms_key = 'base:modals:rebate_claim_modal_title_text_reward_only';
                        if (parseFloat($scope.productDetailData.rebate.amount) > 0 && $scope.productDetailData.rebate.kit !== null){
                            rebate_title_cms_key = 'base:modals:rebate_claim_modal_title_text_reward_plus_kit';
                        } else if (parseFloat($scope.productDetailData.rebate.amount) === 0 && $scope.productDetailData.rebate.kit !== null){
                            rebate_title_cms_key = 'base:modals:rebate_claim_modal_title_text_kit_only';
                        }
                        CmsContentService.getMarketPlaceText(rebate_title_cms_key).then(function(text){
                            $scope.rebate_claim_modal_title_text = text;
                        });

                    };

                    var modal = $('#rebate-processing');

                    modal.on('show.bs.modal', function() {
                        $scope.getRebateInfo();
                        $scope.checkUserStatus();
                        processCMSData();
                    });

                    /**
                     * Gets the current rebate and creates the valid until text
                     */
                    $scope.getRebateInfo = function () {
                        var newProductDetailData = IndexService.getRebateDisplay();
                        if ($scope.productDetailData !== newProductDetailData) {
                            $scope.emailSent = false;
                            $scope.productDetailData = newProductDetailData;
                            // For backwards compatibility, use the highest rebate
                            $scope.productDetailData.rebate = RebatesService.getHighestRebateForClaimTab($scope.productDetailData.rebates);
                            $scope.rebate = $scope.productDetailData.rebate;
                            $scope.allowInstantRebate = $scope.rebate.is_instant;

                    }
                };

                    /**
                     * Checks whether or not the user is authenticated when the modal opens and sends the email if necessary.
                     * If a user is authenticated, this updates the userEmail to prefill necessary fields.
                     */
                    $scope.checkUserStatus = function() {
                        $scope.is_authenticated = AccountAuthService.isAuthenticated();
                        visitorType = AccountAuthService.getUserStatus();
                        if($scope.sendEmail){
                            $scope.sendEmail = false;
                            $scope.emailInfo();
                        }
                        if ($scope.is_authenticated){
                            if (AccountAuthService.getCurrentUser() === null){
                                AccountAuthService.fetchCurrentUserInfo().then(function(){
                                    $scope.userEmail = AccountAuthService.getCurrentUserEmail();
                                });
                            } else {
                                $scope.userEmail = AccountAuthService.getCurrentUserEmail();
                            }
                        } else {
                            $scope.emailSent = false;
                        }
                    };

                    /**
                     * Runs on 'Submit Your Receipt' click. Utilizes RebatesService to ensure basic validation,
                     * ie that the user is logged in and a valid image has been chosen. Displays an error if necessary,
                     * or continues with submission if data is valid.
                     */
                    $scope.submitReceipt = function(){
                        // the user is wanting to upload a receipt, no need to send email
                        $scope.sendEmail = false;
                        $scope.formError = null;
                        var data = {
                            'email': $scope.userEmail,
                            'product_id': $scope.productDetailData.id,
                            'rebate_id': $scope.rebate.id,
                            'receipt_image': $scope.receipt
                        };
                        var response = RebatesService.verifyRebateInfo(data, true);
                        if (response === null) {
                            IndexService.closeModal('#rebate-processing');
                        } else if ('error' in response){
                            $scope.formError = response.error;
                        } else {
                            $scope.handleUploadResponse(data);
                        }

                        var trackingData = {
                            process_type: 'easy rebate',
                            process_step: 'upload receipt',
                            location: 'modal'
                        };
                        RebatesService.trackIncentiveEngaged('Engaged', trackingData, $scope.productDetailData);
                    };

                    /**
                     * Runs on 'Email Me Rebate Information' click. Uses RebatesService to check user status and
                     * to create a partial user if the account does not exist. If the validation is passed, the
                     * request is passed to the backend to send the email
                     */
                    $scope.submitEmail = function(){
                        RebatesService.verifyEmailInfo(
                            $scope.userEmail,
                            $scope.productDetailData.id,
                            $scope.rebate.id,
                            "#" + modal.attr('id')
                        ).then(function (response) {
                            if (response.success) {
                                $scope.emailSent = true;
                                var trackingData = {
                                    process_type: 'email rebate',
                                    process_step: 'email info',
                                    location: 'modal'
                                };
                                RebatesService.trackIncentiveEngaged('Engaged', trackingData, $scope.productDetailData);
                            } else {
                                $scope.formError = response.message;
                            }
                        });
                    };

                    /**
                     * Runs on 'I'm not ready' click. Utilizes RebatesService to ensure the user is logged in
                     * before sending info. If user is logged in, submission is triggered.
                     */
                    $scope.emailInfo = function() {
                        $scope.receipt = {};
                        var data = {
                            'email': $scope.userEmail,
                            'product_id': $scope.productDetailData.id,
                            'rebate_id': $scope.rebate.id
                        };
                        var response = RebatesService.emailRebateInfo(data, true);
                        if (response === null) {
                            IndexService.closeModal('#rebate-processing');
                            $scope.sendEmail = true;
                        } else {
                            $scope.sendEmail = false;
                            $scope.handleEmailResponse(data);
                        }

                        var trackingData = {
                            process_type: 'email rebate',
                            process_step: 'email info',
                            location: 'modal'
                        };
                        RebatesService.trackIncentiveEngaged('Engaged', trackingData, $scope.productDetailData);
                    };

                    /**
                     * Handles error messaging and success message display based on the response
                     * received from the backend via RebatesService.
                     * @param data
                     */
                    $scope.handleUploadResponse = function(data) {
                        RebatesService.uploadInfo(data).then(function(response){
                            if (response.data.success) {
                                // if upload is successful, show a success alert
                                $scope.receipt.result = response.data.message;
                                var alerts = [{
                                    type: 'success',
                                    message: $scope.receipt.result
                                }];
                                IndexService.setHeaderAlerts(alerts);
                                $scope.receipt = null;
                                IndexService.closeModal('#rebate-processing');
                            } else if (response.status > 0) {
                                // if we get a response that's not a 200 ok, display the error
                                $scope.formError = response.statusText;
                            } else {
                                // if upload is not successful, display the error
                                $scope.receipt.result = response.data.error;
                                $scope.formError = $scope.receipt.result;
                            }
                        });
                    };

                    /**
                     * Handles the success and errors that may come up from the email rebate API
                     */
                    $scope.handleEmailResponse = function(data) {
                        RebatesService.sendEmailInfo(data).then(function (response) {
                            if (response.success) {
                                var alerts = [{
                                    type: 'success',
                                    message: response.message
                                }];
                                IndexService.setHeaderAlerts(alerts);
                                IndexService.closeModal('#rebate-processing');
                            } else {
                                $scope.formError = response.message;
                            }
                        });
                    };

                    /**
                     * Display the instant rebate modal
                     */
                    $scope.openInstantRebateModal = function() {
                        IndexService.closeModal('#rebate-processing');
                        RebatesService.trackIncentiveClicked($scope.rebate, $scope.productDetailData, 'modal');
                        RebatesService.openInstantRebateModal($scope.productDetailData.id);
                    };

                    /**
                     * Handles when the rebate link is clicked.
                     * Fires a tracking event.
                     *
                     * @param {Event} e the 'click' event from the link
                     */
                    $scope.handleClickedRebateLink = function(e) {
                        RebatesService.trackIncentiveClicked($scope.rebate, $scope.productDetailData, 'modal');
                    };

                }],
            template: require('@app/shared/modals/rebates/rebates.html'),
        };

    }]);

})(angular);
